import { render, staticRenderFns } from "./LiveChatModal.vue?vue&type=template&id=ccbded9a&scoped=true&"
import script from "./LiveChatModal.vue?vue&type=script&lang=js&"
export * from "./LiveChatModal.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatModal.vue?vue&type=style&index=0&id=ccbded9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbded9a",
  null
  
)

export default component.exports